export default "__VITE_ASSET__Bsr9Q9km__"